// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PqiB84WaI0PamBvxVvndN{background-color:#ffffff;height:100vh}\n", "",{"version":3,"sources":["webpack://src/client/pages/shoppingcart/pages/fb-checkout-url/style.module.scss"],"names":[],"mappings":"AAEA,uBACE,wBAAyB,CACzB,YAAa","sourcesContent":["@import '../../../../base.scss';\n\n.Container{\n  background-color: #ffffff;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": "PqiB84WaI0PamBvxVvndN"
};
module.exports = ___CSS_LOADER_EXPORT___;
